import clsx from "clsx";

export type FormInputLabelProps = {
    htmlFor?: string;
    children: string | React.ReactNode;
    required?: boolean;
    tooltipText?: string;
    className?: string;
};

const FormInputLabel = ({
    htmlFor,
    children,
    required,
    tooltipText,
    className,
}: FormInputLabelProps) => {
    return (
        <label
            htmlFor={htmlFor}
            className={clsx(
                "text-sm mb-1 flex flex-row items-center",
                className
            )}
        >
            {required && (
                <span
                    className="text-red-40 font-bold text-label mr-1"
                    aria-hidden="true"
                >
                    {" "}
                    *{" "}
                </span>
            )}
            {children}
        </label>
    );
};

export default FormInputLabel;
